import { render, staticRenderFns } from "./ygpjxq.vue?vue&type=template&id=7c491757&scoped=true&"
import script from "./ygpjxq.vue?vue&type=script&lang=js&"
export * from "./ygpjxq.vue?vue&type=script&lang=js&"
import style0 from "./ygpjxq.vue?vue&type=style&index=0&id=7c491757&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c491757",
  null
  
)

export default component.exports